import { createSlice } from '@reduxjs/toolkit'
import React from 'react'

const initialState = {
  favoriteItem : [],
  totalQuality: 0
}

 const favoriteSlice = createSlice({
    name: 'favoriteslice',
    initialState,
    reducers: {
        addTofavorite(state, action){
            const newitem = action.payload;
            const existing = state.favoriteItem.find((item) => item.id === newitem.id);
            if(!existing){
                state.totalQuality++;
            state.favoriteItem.push({
                id: newitem.id,
                image: newitem.image,
                title: newitem.title,
                price: newitem.price
            })
            }else{

            }
        },
        rmvfavorite(state, action){
            state.totalQuality--;
            const id = action.payload;
            state.favoriteItem = state.favoriteItem.filter((item) => item.id !== id)
           
        }
    }
})

export const favoriteSliceAction = favoriteSlice.actions;
export default favoriteSlice;